import classNames from "classnames";
import React, { useEffect, useState } from 'react'
import EclipseGoTo from "./EclipseGoTo";
import GotoPageEntire from "./GotoPageEntire";
import SingleChangeButton from "./SingleChangeButton";


const Pagination = ({
  pageSize,
  page,
  totalItems,
  onChange,
  messages = {
    next: "Next",
    previous: "previous",
    showing: "Showing",
    to: "to",
    of: "of"
  },
  ...props
}) => {

  const [list, setList] = useState([]);
  const pageCount = Math.ceil(totalItems / pageSize);

  useEffect(() => {
    setList(paginationPageList(page, pageCount));
  }, [onChange]);

  const previous = (event) => {
    event.preventDefault();
    if (page === 1) {
      return;
    }
    onChange(page - 1)
  };


  const next = (event) => {
    event.preventDefault();
    if (page === pageCount) {
      return;
    }
    onChange(page + 1)
  }

  const goto = (event, page) => {
    event.preventDefault();
    onChange(page)
  }


  const paginationPageList = (currentPage, numberOfPages) => {
    const start = Math.max(currentPage - 5, 1);
    const end = Math.min(start + 9, numberOfPages);

    const pageList = [];

    if (start !== 1) {
      pageList.push(<GotoPageEntire page={1}
                                    key={start + "-" + 1 + "-" + end}
                                    currentPage={currentPage}
                                    onChange={(event) => goto(event, 1)}
      />);
      pageList.push(<EclipseGoTo currentpage={currentPage}/>);
    }

    for (let index = start; index <= end; ++index) {
      pageList.push(<GotoPageEntire page={index}
                                    key={start + "-" + index + "-" + end}
                                    currentPage={currentPage}
                                    onChange={(event) => goto(event, index)}
      />);
    }

    if (end !== numberOfPages) {
      pageList.push(<EclipseGoTo currentpage={currentPage}/>);

      pageList.push(<GotoPageEntire page={pageCount}
                                    key={start + "-" + pageCount + "-" + end}
                                    currentPage={currentPage}
                                    onChange={(event) => goto(event, pageCount)}
      />);
    }

    return pageList;
  }

  return (
    <div
      className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
      <div className="flex-1 flex justify-between sm:hidden">
        <SingleChangeButton onChange={previous} messages={messages.previous}/>
        <SingleChangeButton next onChange={next} messages={messages.next}/>
      </div>
      <div
        className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
        <div>
          {messages.showing + " " + (pageSize * (page - 1)) + " " + messages.to + " " + (pageSize * (page)) + " " + messages.of + " " + totalItems}
        </div>
        <div>
          <nav
            className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
            aria-label="Pagination">
            <SingleChangeButton desktop onChange={previous}
                                messages={messages.previous}/>
            {list}
            <SingleChangeButton next desktop onChange={next}
                                messages={messages.next}/>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
